import React from "react";
import { Box, IconButton, Badge, useDisclosure, Tooltip } from "@chakra-ui/react";
import { FiShoppingCart } from "react-icons/fi";
import { useCart } from "../context/CartContext";
import CartDrawer from "./CartDrawer";

const FloatingCartButton = () => {
  const { cart } = useCart();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <>
      <Box
        position="fixed"
        bottom={{ base: 6, md: 10 }}
        right={{ base: 6, md: 10 }}
        zIndex={1500}
        boxShadow="2xl"
        borderRadius="full"
        bg="white"
        p={2}
        display="flex"
        alignItems="center"
        justifyContent="center"
        _hover={{ boxShadow: "dark-lg", bg: "green.50" }}
        transition="all 0.2s"
      >
        <Tooltip label="View Cart" hasArrow placement="left">
          <Box position="relative">
            <IconButton
              icon={<FiShoppingCart size={28} />}
              colorScheme="green"
              aria-label="Open cart"
              size="lg"
              borderRadius="full"
              onClick={onOpen}
              bg="green.500"
              color="white"
              _hover={{ bg: "green.600" }}
              boxShadow="md"
            />
            {itemCount > 0 && (
              <Badge
                position="absolute"
                top={-2}
                right={-2}
                bg="red.500"
                color="white"
                borderRadius="full"
                px={2}
                fontSize="xs"
                fontWeight="bold"
                boxShadow="md"
              >
                {itemCount}
              </Badge>
            )}
          </Box>
        </Tooltip>
      </Box>
      <CartDrawer isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default FloatingCartButton;
